import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The homepage moved to /welcome. This stub stays so existing inbound links,
 * the old prerendered snapshot and any bookmark keep working.
 */
export const Route = createFileRoute("/home")({
  beforeLoad: () => {
    throw redirect({ to: "/welcome", replace: true });
  },
});
